module.exports = __webpack_public_path__ + "static/media/login.1dc12c3c.png";